import { jsx, jsxs } from "react/jsx-runtime";
import * as Dialog from "@radix-ui/react-dialog";
import { DialogTrigger } from "@radix-ui/react-dialog";
import clsx from "clsx";
import { IconButton, Button } from "./button.js";
import { CloseIcon } from "@blocksuite/icons";
import { a as assignInlineVars } from "./vanilla-extract-dynamic.esm-b0bca947.js";
import { forwardRef } from "react";
import "./loading.js";
const styles_css_ts_vanilla = "";
var closeButton = "_3lpfcy5";
var confirmModalContainer = "_3lpfcya";
var confirmModalContent = "_3lpfcy9";
var heightVar = "var(--_3lpfcy1)";
var minHeightVar = "var(--_3lpfcy2)";
var modalContent = "_3lpfcy4";
var modalDescription = "_3lpfcy7";
var modalFooter = "_3lpfcy8";
var modalHeader = "_3lpfcy6";
var modalOverlay = "_3lpfcy3";
var widthVar = "var(--_3lpfcy0)";
const getVar = (style = "", defaultValue = "") => {
  return style ? typeof style === "number" ? `${style}px` : style : defaultValue;
};
const Modal = forwardRef(
  ({
    width,
    height,
    minHeight = 194,
    title,
    description,
    withoutCloseButton = false,
    portalOptions,
    contentOptions: {
      style: contentStyle,
      className: contentClassName,
      ...otherContentOptions
    } = {},
    overlayOptions: {
      className: overlayClassName,
      ...otherOverlayOptions
    } = {},
    closeButtonOptions = {},
    children,
    ...props
  }, ref) => /* @__PURE__ */ jsx(Dialog.Root, { ...props, children: /* @__PURE__ */ jsxs(Dialog.Portal, { ...portalOptions, children: [
    /* @__PURE__ */ jsx(
      Dialog.Overlay,
      {
        className: clsx(modalOverlay, overlayClassName),
        ...otherOverlayOptions
      }
    ),
    /* @__PURE__ */ jsxs(
      Dialog.Content,
      {
        className: clsx(modalContent, contentClassName),
        style: {
          ...assignInlineVars({
            [widthVar]: getVar(width, "50vw"),
            [heightVar]: getVar(height, "unset"),
            [minHeightVar]: getVar(minHeight, "26px")
          }),
          ...contentStyle
        },
        ...otherContentOptions,
        ref,
        children: [
          withoutCloseButton ? null : /* @__PURE__ */ jsx(Dialog.Close, { asChild: true, children: /* @__PURE__ */ jsx(
            IconButton,
            {
              className: closeButton,
              "aria-label": "Close",
              type: "plain",
              ...closeButtonOptions,
              children: /* @__PURE__ */ jsx(CloseIcon, {})
            }
          ) }),
          title ? /* @__PURE__ */ jsx(Dialog.Title, { className: modalHeader, children: title }) : null,
          description ? /* @__PURE__ */ jsx(Dialog.Description, { className: modalDescription, children: description }) : null,
          children
        ]
      }
    )
  ] }) })
);
Modal.displayName = "Modal";
const ConfirmModal = ({
  children,
  confirmButtonOptions,
  // FIXME: we need i18n
  cancelText = "Cancel",
  cancelButtonOptions,
  onConfirm,
  width = 480,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(Modal, { contentOptions: { className: confirmModalContainer }, width, ...props, children: [
    children ? /* @__PURE__ */ jsx("div", { className: confirmModalContent, children }) : null,
    /* @__PURE__ */ jsxs("div", { className: clsx(modalFooter, {
      "modalFooterWithChildren": !!children
    }), children: [
      /* @__PURE__ */ jsx(DialogTrigger, { asChild: true, children: /* @__PURE__ */ jsx(Button, { ...cancelButtonOptions, children: cancelText }) }),
      /* @__PURE__ */ jsx(Button, { onClick: onConfirm, ...confirmButtonOptions })
    ] })
  ] });
};
export {
  ConfirmModal,
  Modal
};
